export default {
  dashboard: {
    title: "Dashboard",
    prevDay: "上一天",
    nextDay: "下一天",
    waitDispatch: "待派单",
    dispatched: "已派单",
    pickUp: "接机",
    reservation:"预约用车",
    dropOff: "送机",
    charter: "包车",
    useDate: "用车时间：",
    driver: "驾车司机：",
    carTypes: {
      blackBenz: "白君 (奔驰S)",
      silverBenz: "银刃 (奔驰S)",
      goldenBenz: "金鹰 (奔驰S)",
      whiteElfa: "白武士 (埃尔法)",
      blackElfa: "黑武士 (埃尔法)",
      blackMaybach: "黑梦 (迈巴赫)",
      'whiteMaybach': '白梦 (迈巴赫)'
    },
    orderTailNumber: "订单尾号：",
    monthWorkTime: "{month}月份工作时长预估：",
    dayWorkTime: "{date} 工作时长预估：",

    dispatchCar: "立即派车",
    selectDriver: "请选择司机",
    selectCarType: "请选择车辆",
    dispatchPopTitle: "选择司机/车辆",
    car: "车辆",
    dispatchSuccess: "派车成功",
    using: "行程中",
    useDate2: "用车时间",
    orderInfo: "下单信息",
    carInfo: "车辆信息",
    orderType: "用车类型：",
    journey: "行程",
    airport: "降落机场：",
    NaritaAirport: "东京成田机场",
    HanedaAirport: "东京羽田机场",
    startAddress: "上车地点：",
    startAirport: "起飞机场：",
    destinationAddress: "下车地点：",
    planeNo: "航班号：",
    travelOverrun: "行程超限：",
    overrunDistance: "超限路程：",
    overrunTime: "超限时长：",
    yes: "是",
    no: "否",
    passenger: "乘客",
    passengerName: "姓名：",
    telephone: "手机号：",
    wechat: "微信号：",
    peopleNum: "人数：",
    child: "小孩：",
    none: "无",
    have: "有",
    luggage: "行李：",
    carService: "车服务",
    expectCarType: "期望车型：",
    expectTemperature: "期望车内温度：",
    expectLanguage: "期望服务语言：",
    Chinese: "中文",
    English: "英文",
    Japanese: "日文",
    pickUpRequire: "接机要求：",
    dropOffRequire: "送机要求：",
    allergy: "有无过敏：",
    remark: "备注：",
    linkedOrder: "关联酒店订单：",
    vehicleDispatching: "派车",
    carType: "车型：",
    carNo: "车牌：",
    driverName: "司机姓名：",
    driverTelephone: "司机手机号：",
    driverWechat: "司机微信号：",
    orderNo: "订单号：",
    bookingDate: "下单时间：",
    startJourney: "开始行程",
    finishJourney: "结束行程",
    dashboardPhotos: "仪表盘拍照：",
    dashboardPhotosTips: "请上传仪表盘拍照",
    dashboardNum: "仪表盘读数：",
    dashboardNumTips: "请填写仪表盘读数",
    confirmStartJourney: "确定开始行程？",
    confirmFinishJourney: "确定结束行程？",
    vehicleDispatch: "车辆调度",
    orderCount: "共{count}条订单",
    status: {
      waitingDispatching: "待派车",
      bookingSucceeded: "未开始",
      waitingCompleting: "行程中",
      completed: "已完成",
      canceled: "已取消"
    },
    dashboardTips: "读数需大于{count}公里",
    journeyRemark: "行程备注:",
    copyOrder: "复制订单",
    delivery: "出库：",
    warehousing: "入库：",
    deliveryTime: "出库时间：",
    warehousingTime: "入库时间：",
    accessories: "备品：",
    productsSold: "卖出商品：",
    additionalCost: "额外费用：",
    Mr: "先生",
    Ms: "女士",
    countUnit: "位",
    kilometer: "公里",
    minute: "分钟",
    age: "年龄"
  }
};
